/**
 * Header — Gumyum Theme (ProperHealth style)
 * Mega menu toggle, search modal, cart drawer, shipping bar
 */
(function() {
  'use strict';

  var header = document.getElementById('site-header');
  if (!header) return;

  /* ---- Sticky header shadow on scroll ---- */
  window.addEventListener('scroll', function() {
    if (window.scrollY > 80) {
      header.classList.add('header--scrolled');
    } else {
      header.classList.remove('header--scrolled');
    }
  }, { passive: true });

  /* ---- Mega menu toggle (click to open/close) ---- */
  var megaToggle = document.querySelector('[data-mega-toggle]');
  var megaMenu = document.getElementById('mega-menu-shop');
  var navItem = megaToggle ? megaToggle.closest('.nav-item--has-mega') : null;

  /* Shop link: click navigates to /collections/all, hover shows dropdown */
  if (megaToggle && megaMenu && navItem) {
    // Click navigates — don't prevent default
    // Dropdown shows via CSS :hover only
  }

  /* ---- Search modal ---- */
  var searchModal = document.getElementById('search-modal');
  var searchInput = searchModal ? searchModal.querySelector('.search-modal__input') : null;

  document.querySelectorAll('[data-open-search]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (searchModal) {
        searchModal.classList.add('is-open');
        searchModal.setAttribute('aria-hidden', 'false');
        if (searchInput) searchInput.focus();
      }
    });
  });

  document.querySelectorAll('[data-close-search]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (searchModal) {
        searchModal.classList.remove('is-open');
        searchModal.setAttribute('aria-hidden', 'true');
      }
    });
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchModal && searchModal.classList.contains('is-open')) {
      searchModal.classList.remove('is-open');
      searchModal.setAttribute('aria-hidden', 'true');
    }
  });

  /* ---- Predictive search ---- */
  if (searchInput) {
    var searchResults = document.getElementById('search-results');
    var debounceTimer;

    searchInput.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      var query = this.value.trim();
      if (query.length < 3) {
        if (searchResults) searchResults.innerHTML = '';
        return;
      }

      debounceTimer = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            if (!searchResults) return;
            var products = data.resources && data.resources.results && data.resources.results.products || [];
            if (products.length === 0) {
              searchResults.innerHTML = '<p style="padding:16px 0;color:var(--color-text-muted);">No results found</p>';
              return;
            }
            var html = '<div style="display:grid;grid-template-columns:repeat(3,1fr);gap:16px;">';
            products.forEach(function(p) {
              var img = p.image || '';
              html += '<a href="' + p.url + '" style="text-decoration:none;color:var(--color-text);">';
              if (img) html += '<img src="' + img + '" alt="" style="width:100%;aspect-ratio:1;object-fit:cover;border-radius:8px;margin-bottom:8px;" loading="lazy">';
              html += '<p style="font-size:13px;font-weight:600;">' + p.title + '</p>';
              html += '<p style="font-size:13px;color:var(--color-text-muted);">' + p.price + '</p>';
              html += '</a>';
            });
            html += '</div>';
            searchResults.innerHTML = html;
          })
          .catch(function() {});
      }, 300);
    });
  }

  /* ---- Shipping progress bar ---- */
  window.updateShippingBar = function(cartTotal) {
    var bar = document.getElementById('shipping-bar');
    var fill = document.getElementById('shipping-fill');
    var text = document.getElementById('shipping-text');
    var drawer = document.querySelector('.cart-drawer');
    if (!bar || !fill || !text || !drawer) return;

    var threshold = parseInt(drawer.dataset.shippingThreshold) || 1000;
    var totalInRupees = cartTotal / 100;

    if (totalInRupees >= threshold) {
      text.innerHTML = 'You qualify for <strong>free shipping!</strong>';
      fill.style.width = '100%';
      bar.classList.add('is-free');
    } else {
      var remaining = Math.ceil(threshold - totalInRupees);
      text.innerHTML = 'You\'re <strong>\u20B9' + remaining + '</strong> away from free shipping!';
      var pct = Math.min((totalInRupees / threshold) * 100, 100);
      fill.style.width = pct + '%';
      bar.classList.remove('is-free');
    }
  };

  /* ---- Focus trap for drawers ---- */
  function trapFocus(element) {
    var focusable = element.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (focusable.length === 0) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    element.addEventListener('keydown', function(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  var cartDrawer = document.querySelector('.cart-drawer');
  if (cartDrawer) trapFocus(cartDrawer);

  var mobileDrawer = document.querySelector('.mobile-nav-drawer');
  if (mobileDrawer) trapFocus(mobileDrawer);

  // Close drawers on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      if (cartDrawer && cartDrawer.classList.contains('active')) {
        cartDrawer.classList.remove('active');
        var cartOverlay = document.querySelector('.cart-overlay');
        if (cartOverlay) cartOverlay.classList.remove('active');
      }
      if (mobileDrawer && mobileDrawer.classList.contains('active')) {
        mobileDrawer.classList.remove('active');
        var navOverlay = document.querySelector('.mobile-nav-overlay');
        if (navOverlay) navOverlay.classList.remove('active');
      }
    }
  });
})();
